"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convert = void 0;
const importers_1 = require("./importers");
const utils_1 = require("./utils");
const convert = async (rawData) => {
    for (const importer of importers_1.importers) {
        const resources = await importer.convert(rawData);
        if (!resources) {
            continue;
        }
        if (resources.length > 0 && resources[0].variable) {
            resources[0].environment = resources[0].variable;
        }
        const convertedResult = {
            type: {
                id: importer.id,
                name: importer.name,
                description: importer.description,
            },
            data: {
                _type: 'export',
                __export_format: 4,
                __export_date: new Date().toISOString(),
                __export_source: 'insomnia.importers:v0.1.0',
                resources: resources.map(utils_1.setDefaults),
            },
        };
        return convertedResult;
    }
    throw new Error('No importers found for file');
};
exports.convert = convert;
//# sourceMappingURL=convert.js.map